<script>
    import Router from 'svelte-spa-router';

	import Menu from "./menu.svelte";
	import Base1 from "./base1/base1.svelte";
	import Home from "./base1/home.svelte";
	import Base2 from "./base2/base2.svelte";
	import Overview from "./base2/overview.svelte";
	import Base3 from "./base3/base3.svelte";
	import Introduce from "./base3/introduce.svelte";
	import Sarch from "./base3/sarch.svelte";
	import Base4 from "./base4/base4.svelte";
	import Theme from "./base4/theme.svelte";
	import Base5 from "./base5/base5.svelte";
	import Map from "./base5/map.svelte";
	import Base6 from "./base6/base6.svelte";
	import Access from "./base6/access.svelte";
	import Base7 from "./base7/base7.svelte";
	import Contact from "./base7/contact.svelte";
	import Policy from "./policy.svelte";

    const routes = {
		'/menu': Menu,
		'/base1': Base1,
		'/home': Home,
		'/base2': Base2,
		'/overview': Overview,
		'/base3': Base3,
		'/introduce': Introduce,
		'/sarch': Sarch,
		'/base4': Base4,
		'/theme': Theme,
		'/base5': Base5,
		'/map': Map,
		'/base6': Base6,
		'/access': Access,
		'/base7': Base7,
		'/contact': Contact,
		'/policy': Policy,
		'*': Base1,
    };
</script>

<Router routes={routes}/>